
import { AiFillLinkedin } from "react-icons/ai";
import { AiFillGithub } from "react-icons/ai";
import { AiOutlineTwitter } from "react-icons/ai";
import { AiOutlineMail } from "react-icons/ai";
import statusImg from "../assets/status.png";
import Abdullateef_resume from "../assets/abdullateef_resume.pdf";

export const Hero = () => {
  return (
    <section className="flex flex-col-reverse mt-5 sm:flex-row sm:justify-between lg:min-h-screen bg-[#021227] px-8 sm:px-16 py-4 max-w-screen-xl mx-auto">
      {/* Left Side */}
      <div className="sm:w-3/5">
        <p
          style={{ fontFamily: "'Roboto Mono', monospace;" }}
          className="text-[#309543] mt-[50px] lg:mt-[80px] font-semibold"
        >
          Hi, my name is
        </p>
        <h2 className="text-4xl lg:text-5xl xl:text-6xl	font-bold text-[#cccccc] mt-5 lg:mt-3">
          Abdullateef.
        </h2>
        <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold mt-3 lg:mt-5">
          <span className="text-[#247032]">Full Stack</span> Developer
        </h2>

        <p className="mt-6 lg:mt-7 max-w-md text-xl text-[#cccccc]">
          I’m a full-stack developer who thrives on turning ideas into scalable,
          real-world solutions. I enjoy working across the stack—from crafting
          sleek, responsive UIs to designing robust backend systems. Building
          products that make an impact and solving complex challenges are what
          drive me forward. <br />
          <span
            style={{ fontFamily: "'Roboto Mono', monospace" }}
            className="font-bold text-[#309543]"
          >
            Open to Exciting Opportunities & Collaboration.
          </span>
        </p>

        <div className="">
          <div className="mt-12">
            <a
              href={Abdullateef_resume}
              download="resume.pdf"
              style={{ fontFamily: "'Roboto Mono', monospace;" }}
              className="px-6 py-3 text-[#309543] border-2 border-[#309543] font-bold transition-all hover:bg-[#30954232] rounded-md"
            >
              Download Resume !
            </a>
          </div>
        </div>
        {/* social Links */}
        <div className="mt-12">
          <ul className="flex gap-4">
            <li className="mr-2 flex justify-center items-center">
              <a
                href="https://www.linkedin.com/in/abdullateef-kolawole/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-[35px] h-[35px]"
              >
                <AiFillLinkedin className="w-[35px] h-[35px] transition-all hover:text-[#309543]" />
              </a>
            </li>
            <li className="mr-2 flex justify-center items-center">
              <a
                href="https://github.com/BrainiacDev"
                target="_blank"
                rel="noopener noreferrer"
                className="w-[35px] h-[35px]"
              >
                <AiFillGithub className="w-[35px] h-[35px] transition-all hover:text-[#309543]" />
              </a>
            </li>
            <li className="mr-2 flex justify-center items-center">
              <a
                href="https://twitter.com/Holarzkid12"
                target="_blank"
                rel="noopener noreferrer"
                className="w-[35px] h-[35px]"
              >
                <AiOutlineTwitter className="w-[35px] h-[35px] transition-all hover:text-[#309543]" />
              </a>
            </li>
            <li className="mr-2 flex justify-center items-center">
              <a
                href="mailto: olasunkanmiabdullateef@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-[35px] h-[35px]"
              >
                <AiOutlineMail className="w-[35px] h-[35px] transition-all hover:text-[#309543]" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* right side */}
      <div className="hidden sm:block sm:w-2/5">
        <img
          src={statusImg}
          className="hover:filter hover:saturate-200 transition duration-500"
          alt="hero-img"
        />
      </div>
    </section>
  );
};
